export default {
  schedules: {
    type: Array,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/components/delayed/resources/props.js